import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿El contenido es digital o físico?',
  a: 'Es 100% digital. Recibirás acceso inmediato a los archivos en PDF para que los puedas leer en tu celular, tablet o computadora, e incluso imprimirlos si lo prefieres.'
}, {
  q: '¿Necesito conocimientos previos de botánica?',
  a: 'Para nada. El manual está escrito en un lenguaje sencillo para el hogar. Te llevamos de la mano desde cero.'
}, {
  q: '¿Las plantas son difíciles de conseguir?',
  a: 'No. El 90% de las plantas las encuentras en el mercado local o incluso ya las tienes en tu cocina. El manual se enfoca en hierbas accesibles para el mundo hispano.'
}, {
  q: '¿El pago es seguro?',
  a: 'Absolutamente. Utilizamos plataformas de pago líderes que protegen tus datos. Puedes pagar con tarjeta de crédito, débito o PayPal.'
}, {
  q: '¿Puedo comprarlo si no vivo en Estados Unidos?',
  a: 'Sí. El sistema detecta tu país y podrás pagar en tu moneda local (pesos mexicanos, colombianos, euros, etc.) con los métodos de pago disponibles en tu región.'
}, {
  q: '¿En cuánto tiempo recibo el material después de pagar?',
  a: 'De forma inmediata. Apenas se confirme tu pago, recibirás un correo electrónico con el enlace de acceso a todos los manuales y bonos.'
}, {
  q: '¿Es seguro combinar estos remedios con mis medicamentos actuales?',
  a: 'El manual incluye una sección de contraindicaciones detallada. Sin embargo, si tomas medicación crónica, siempre te recomendamos consultar con tu médico de confianza antes de iniciar cualquier tratamiento natural.'
}, {
  q: '¿Funciona para personas mayores de 60 años?',
  a: 'Sí, de hecho la mayoría de nuestros lectores tienen entre 50 y 75 años. Las dosis y preparaciones están pensadas para ser suaves, seguras y efectivas a cualquier edad.'
}, {
  q: '¿Puedo compartir el manual con mi familia?',
  a: 'Por supuesto. Una vez descargado, puedes consultarlo con tu pareja, hijos o nietos. Es un legado de salud que se queda contigo para siempre.'
}, {
  q: '¿Qué pasa si no me gusta o no obtengo resultados?',
  a: 'Tienes 14 días de garantía total. Si por cualquier razón no estás satisfecha, escríbenos un correo y te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 sm:py-12 px-4 bg-brand-paper" data-id="element-44">
      <div className="max-w-2xl mx-auto" data-id="element-45">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl sm:text-3xl font-serif font-bold text-center mb-5 sm:mb-8 text-brand-forest leading-tight" data-id="element-46">
          ❓ Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-47">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.03
        }} className="bg-white border border-brand-border rounded-xl overflow-hidden shadow-sm" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-paper-soft transition-colors gap-4" data-id="element-49">
                <span className="font-bold text-brand-forest text-xs sm:text-base leading-snug" data-id="element-50">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-terracotta transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>

              <AnimatePresence data-id="element-52">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-53">
                    <div className="px-5 pb-4 pt-0 text-xs sm:text-sm text-brand-muted font-medium leading-relaxed" data-id="element-54">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}